import { ChartPt, ObsItem } from '../models'

export const mapItemsToChartPoints = (items: ObsItem[], stnId: string): ChartPt[] => {
  return items
    .map(v => ({
      t: v.timestamp,
      v: v.readings.find(r => r.station_id === stnId)?.value ?? null,
    }))
    .filter(v => v.t !== null && v.v !== null)
    .map(({ t, v }) => ({ t: new Date(t).getTime(), v: parseFloat(v!) }))
}
